<template>
	<md-card>
		<md-card-header class="md-card-header-icon md-card-header-blue">
			<div class="card-icon">
				<md-icon>{{ icon }}</md-icon>
			</div>
			<h4 class="title">{{ title }}</h4>
		</md-card-header>

		<md-card-content>
			<div class="md-layout">
				<div class="md-layout-item md-size-50">
					<md-field class="md-invalid">
						<label>Nom *</label>
						<md-input :value="value" @input="$emit('update', $event)" type="text"></md-input>
						<validation-error :errors="apiValidationErrors.name" />
					</md-field>
				</div>
			</div>
		</md-card-content>

		<md-card-actions md-alignment="left">
			<md-button class="md-success"
				@click="this.save">
				Enregistrer
			</md-button>
			<md-button class="md-warning"
				@click="this.goBack">
				Retour
			</md-button>
		</md-card-actions>
	</md-card>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
	name: "form-card",
	components: { ValidationError },
	mixins: [formMixin],
	props: {
		title: String,
		icon: String,
		value: String,
		error: Array,
		goBack: Function,
		save: Function
	},
	model: {
		prop: "value",
		event: "update"
	},
	watch: {
		error(value) {
			this.resetApiValidation();
			if(value) {
				this.setApiValidation(value);
			}
		}
	}
}
</script>

<style scoped>

</style>
